import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchMakePage = {
  alert: {
    error: 'apply-search-make-page.form.alert.error',
  },
  footer: {
    root: 'apply-search-make-page.footer.root',
  },
  form: {
    accessibilitySubmit:
      'apply-search-make-page.form.keyboard-only-submit-button',
    getRadioOption: (index: number): string =>
      `apply-search-make-page.form.radio-option-${index + 1}`,
    h1: 'apply-search-make-page.form.h1',
    h2: 'apply-search-make-page.form.h2',
    radioGroupRoot: 'apply-search-make-page.form.radio-group-root',
    root: 'apply-search-make-page.form.root',
  },
} as const satisfies PageLocatorMap;
